import React from "react";

const Career = () => {
  return (
    <section className="min-h-screen bg-white dark:bg-gray-900 mt-16">
      <div className="max-w-3xl mx-auto px-4 py-16 text-center">
        <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-6">
          Careers at Kriptees
        </h1>
        <p className="text-lg text-gray-600 dark:text-gray-300 mb-4">
          We're always on the lookout for passionate, creative minds.
        </p>
        <p className="text-md text-gray-500 dark:text-gray-400 mb-8">
          Currently, there are no open positions at Kriptees. But things move fast — so keep checking back! Whether you're a developer, designer, or someone who just loves fashion and innovation, we’d love to hear from you when the time is right.
        </p>
        <p className="text-sm text-gray-400 italic">
          Stay connected — your dream opportunity might be just around the corner.
        </p>
      </div>
    </section>
  );
};

export default Career;
